<script setup>
import { computed, onBeforeMount, onMounted, ref } from 'vue';
import CharacterCard from './characterCard.vue';
import { update_stats } from '@/services/child';
import { useStore } from 'vuex';
import { swalError, swalSuccess } from '@/helper';

const props = defineProps({
  report: {
    type: Object,
    required: true
  }
})

const isChange = computed(()=>store.state.statistic.isChange)
const reactReport = ref()
onBeforeMount(()=>{
  reactReport.value = props.report
})

// get picture of the report
async function getReport(report){
  report.showSummary = !report.showSummary
}

const store = useStore()
const updating = ref(false)
async function saveSummary(report_id, package_type){
  updating.value = true
  const response = await update_stats(
    report_id, 
    store.getters['statistic/getCharacters'](props.report.package_config.id)
  )
  updating.value = false
  if (response.error){
    swalError(response.result.error, true)
  }else{
    swalSuccess('Report summary has been saved')
  }
}
</script>

<template>
  <div :class="report.showSummary ? 'col-md-8':'col-md-12'">
    <div class="card h-100">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-8">
            <h5>
              {{ report.package_config.options.name.value }}
            </h5>
          </div>
          <div class="col-4 text-end">
            <button class="btn btn-success" 
              @click="saveSummary(report.id)"
              :disabled="!isChange"
            >
              <span v-if="updating">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Updating...</span>
                </div>
              </span>
              <span v-else>
                Save
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <template v-for="character in reactReport.package_config.characters" :key="character.id">
            <CharacterCard v-model:report="reactReport"  :character="character"/>
          </template>
        </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-success float-end" 
          @click="saveSummary(report.id)"
          :disabled="!isChange"
        >
          <span v-if="updating">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Updating...</span>
            </div>
          </span>
          <span v-else>
            Save
          </span>
        </button>
      </div>
    </div>
  </div>
  <div v-if="report.showSummary" class="col-md-4">
    <div class="card card-body h-100">
      <img src="https://placehold.co/600x400" alt="">
    </div>
  </div>
</template>